import React from "react";
import {FormattedMessage} from "react-intl";
import TableRow from "./TableRow";
import Loader from "../Utils/Loader";
import Empty from "./Empty";
import classes from "../RegistryTable/styles.module.css";

function RegistryList({token, data, isLoading}) {
    return isLoading ? (
        data && data.length > 0 ? (
            <div className={classes.TableWrap}>
                <table className={classes.FixedTable}>
                    <colgroup>
                        <col style={{width: "9%"}}/>
                        <col style={{width: "23%"}}/>
                        <col style={{width: "13%"}}/>
                        <col style={{width: "12%"}}/>
                        <col style={{width: "12%"}}/>
                        <col style={{width: "12%"}}/>
                        <col style={{width: "11%"}}/>
                        <col style={{width: "8%"}}/>
                    </colgroup>
                    <thead>
                    <tr>
                        <th className={`${classes.HeaderCell} ${classes.HeaderCenter}`}>
                            <FormattedMessage id="RegistryList.table.id" defaultMessage="Идентификатор"/>
                        </th>
                        <th className={classes.HeaderCell}>
                            <FormattedMessage id="RegistryList.table.status" defaultMessage="Статус"/>
                        </th>
                        <th className={classes.HeaderCell}>
                            <FormattedMessage id="RegistryList.table.merchant" defaultMessage="Мерчант"/>
                        </th>
                        <th className={classes.HeaderCell}>
                            <FormattedMessage id="RegistryList.table.date" defaultMessage="Дата"/>
                        </th>
                        <th className={classes.HeaderCell}>
                            <FormattedMessage id="RegistryList.table.amount" defaultMessage="Сумма"/>
                        </th>
                        <th className={classes.HeaderCell}>
                            <FormattedMessage id="RegistryList.table.fee" defaultMessage="Комиссия"/>
                        </th>
                        <th className={classes.HeaderCell}>
                            <FormattedMessage id="RegistryList.table.tags" defaultMessage="Метки"/>
                        </th>
                        <th className={classes.HeaderCell}/>
                    </tr>
                    </thead>
                    <tbody>
                    {data.length > 0 ? (
                        data.map((el) => (
                            <TableRow
                                key={el.id}
                                token={token}
                                retry={el.retry}
                                id={el.id}
                                name={el.name}
                                date={el.date}
                                amount={el.total}
                                totalFee={el.totalFee}
                                currency={el.currencyCode}
                                status={el.status}
                                success={el.success}
                                failed={el.failed}
                                other={el.other}
                                tags={el.tags}
                                merchantUUID={el.merchantUUID}
                                merchantName={el.merchantName}
                                count={el.transactions_count}
                            />
                        ))
                    ) : (
                        <tr className={classes.EmptyTR}>
                            <td colSpan={8}>
                                <div className={classes.EmptyCell}>
                                    <h5>
                                        <FormattedMessage id="RegistryList.empty" defaultMessage="Реестров не найдено"/>
                                    </h5>
                                </div>
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        ) : (
            <Empty/>
        )
    ) : (
        <Loader/>
    );
}

export default RegistryList;



// WEBPACK FOOTER //
// ./src/Components/RegistryList/index.js